export enum ReferralAdminReferralsFilterEnum {
  ALL = 'all',
  ACTIVATED = 'activated',
  INACTIVE = 'inactive',
  LOCKED = 'locked',
}
